import React, {createContext, useContext, useReducer} from 'react'
import {fetchUserInfo, fetchUserDefaultLocation} from '../api/user'
import {fetchFloor} from '../api/floor'

const UserStateContext = createContext()
const UserDispatchContext = createContext()

const initialState = {
  user: {},
  defaultLocation: {}
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'setUser':
      return {
        ...state,
        user: action.payload
      }

    case 'setDefaultLocation':
      return {
        ...state,
        defaultLocation: action.payload
      }

    case 'setUserData':
      return {
        ...state,
        ...action.payload
      }
  }
}

const fetchAndSetUserInfo = async ({userDispatch}) => {
  const userInfo = await fetchUserInfo()
  userDispatch({type: 'setUser', payload: userInfo})
  return userInfo
}

const fetchAndSetUserDefaultLocation = async ({
  userDispatch,
  blId,
  flId,
  rmId
}) => {
  const defaultLocation = await fetchUserDefaultLocation({
    blId,
    flId,
    rmId
  })

  const {bl, fl, rm} = defaultLocation
  let location = {blId: bl.code, flId: fl.code, rmId: rm.code}
  let isValid = false

  if (bl.code && fl.code) {
    isValid = true
  }

  if (bl.code && !fl.code) {
    location.flId = await fetchFloor({blId: bl.code})
    isValid = true
  }

  // The default location is valid if both building and floor codes exist
  defaultLocation.isValid = isValid
  defaultLocation.location = location
  userDispatch({
    type: 'setDefaultLocation',
    payload: defaultLocation
  })

  return defaultLocation
}

const UserProvider = ({children}) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  return (
    <UserStateContext.Provider value={state}>
      <UserDispatchContext.Provider value={dispatch}>
        {children}
      </UserDispatchContext.Provider>
    </UserStateContext.Provider>
  )
}

function useUserState() {
  const context = useContext(UserStateContext)
  if (!context) {
    throw new Error('useUserState must be used within a UserProvider')
  }
  return context
}

function useUserDispatch() {
  const context = useContext(UserDispatchContext)

  if (!context) {
    throw new Error('useUserDispatch must be used within a UserProvider')
  }
  return context
}

export {
  UserProvider,
  useUserState,
  useUserDispatch,
  fetchAndSetUserInfo,
  fetchAndSetUserDefaultLocation
}
